export default "__VITE_ASSET__DyGBZRpf__"